export var OutputFileType;
(function (OutputFileType) {
    OutputFileType["copyRemoteUrl"] = "copyRemoteUrl";
    OutputFileType["text"] = "text";
    OutputFileType["binary"] = "binary";
})(OutputFileType || (OutputFileType = {}));
export var PulsarExecutor;
(function (PulsarExecutor) {
    PulsarExecutor["supernova"] = "supernova";
    PulsarExecutor["local"] = "local";
})(PulsarExecutor || (PulsarExecutor = {}));
